const AlgebraLatex = require('algebra-latex')
var coffeequate = require('coffeequate')
// var algebrite = require('algebrite')
// var algebraJS = require('algebra.js')

export const unwrap = (str) => {
  str = str.trim()
  str = str.slice(0, -2)
  str = str.slice(2, str.length)

  return str
}

export const compareIsEqual = ({ a, b, equavalents = {}, onError }) => {
  // remvoe the $$
  a = unwrap(a)
  // remvoe the $$
  b = unwrap(b)

  //

  try {
    let algebraObjA = new AlgebraLatex().parseLatex(a).toCoffeequate(coffeequate)
    let algebraObjB = new AlgebraLatex().parseLatex(b).toCoffeequate(coffeequate)

    if (algebraObjA.equals(algebraObjB, equavalents)) {
      return true
    } else {
      return false
    }
  } catch (e) {
    console.error(e)
    onError(e)
    return false
  }
}

/*
MathCompare.compareIsEqual({
  a: filterOutDFrag(studentAns),
  b: filterOutDFrag(possibleAns.line),
  onError: () => {}
})
*/
